const baseUrl: string = ''

export const dashboard: string = `${baseUrl}/dashboard`
export const login: string = `${baseUrl}/login`
export const process: string = `${baseUrl}/process/:id`
export const pay: string = `${baseUrl}/pay/:id`

export const generateProcessLink: string = `https://consultoriomga.com/test-vocacional-online-test/?t=`